/* @flow */
export default {
  backgroundColor: 'white',
  backgroundColor_active: 'gray_20',
  backgroundColor_disabled: 'gray_20',
  backgroundColor_focus: 'white',
  backgroundColor_hover: 'gray_10',
  backgroundColor_brand_selected: 'brand_10',
  backgroundColor_brand_selectedActive: 'brand_30',
  backgroundColor_brand_selectedHover: 'brand_20',
  backgroundColor_brandPrimary: 'brand_60',
  backgroundColor_brandPrimary_active: 'brand_70',
  backgroundColor_brandPrimary_focus: 'brand_60',
  backgroundColor_brandPrimary_hover: 'brand_50',
  backgroundColor_danger_active: 'red_20',
  backgroundColor_danger_focus: 'red_10',
  backgroundColor_danger_hover: 'red_10',
  backgroundColor_dangerPrimary: 'red_60',
  backgroundColor_dangerPrimary_active: 'red_70',
  backgroundColor_dangerPrimary_focus: 'red_60',
  backgroundColor_dangerPrimary_hover: 'red_50',
  backgroundColor_success_active: 'green_20',
  backgroundColor_success_focus: 'green_10',
  backgroundColor_success_hover: 'green_10',
  backgroundColor_successPrimary: 'green_60',
  backgroundColor_successPrimary_active: 'green_70',
  backgroundColor_successPrimary_focus: 'green_60',
  backgroundColor_successPrimary_hover: 'green_50',
  backgroundColor_warning_active: 'bronze_20',
  backgroundColor_warning_focus: 'bronze_10',
  backgroundColor_warning_hover: 'bronze_10',
  backgroundColor_warningPrimary: 'bronze_60',
  backgroundColor_warningPrimary_active: 'bronze_70',
  backgroundColor_warningPrimary_focus: 'bronze_60',
  backgroundColor_warningPrimary_hover: 'bronze_50',
  borderColor: 'gray_40',
  borderColor_brand: 'brand_60',
  borderColor_brand_active: 'brand_70',
  borderColor_brand_focus: 'brand_70',
  borderColor_brand_hover: 'brand_50',
  borderColor_danger: 'red_60',
  borderColor_danger_active: 'red_70',
  borderColor_danger_focus: 'red_70',
  borderColor_danger_hover: 'red_50',
  borderColor_success: 'green_60',
  borderColor_success_active: 'green_70',
  borderColor_success_focus: 'green_70',
  borderColor_success_hover: 'green_50',
  borderColor_warning: 'bronze_60',
  borderColor_warning_active: 'bronze_70',
  borderColor_warning_focus: 'bronze_70',
  borderColor_warning_hover: 'bronze_50',
  color: 'gray_100',
  color_inverted: 'white',
  color_disabled: 'gray_50',
  color_mouse: 'gray_80',
  color_readOnly: 'gray_80',
  color_required: 'red_60',
  color_brand: 'brand_60',
  color_brandPrimary: 'white',
  color_brand_active: 'brand_70',
  color_brand_focus: 'brand_60',
  color_brand_hover: 'brand_50',
  color_danger: 'red_60',
  color_dangerPrimary: 'white',
  color_danger_active: 'red_70',
  color_danger_focus: 'red_60',
  color_danger_hover: 'red_50',
  color_success: 'green_60',
  color_successPrimary: 'white',
  color_success_active: 'green_70',
  color_success_focus: 'green_60',
  color_success_hover: 'green_50',
  color_warning: 'bronze_60',
  color_warningPrimary: 'white',
  color_warning_active: 'bronze_70',
  color_warning_focus: 'bronze_60',
  color_warning_hover: 'bronze_50',
  h1_color: 'gray_100',
  h2_color: 'gray_80',
  h3_color: 'gray_80',
  h4_color: 'gray_80',
  h5_color: 'gray_100',
  h6_color: 'gray_80',
  icon_color: 'gray_80',
  icon_color_brand: 'brand_60',
  icon_color_danger: 'red_60',
  icon_color_success: 'green_60',
  icon_color_warning: 'bronze_60',
  input_backgroundColor: 'white',
  input_backgroundColor_disabled: 'gray_20',
  input_color_placeholder: 'gray_60',
  panel_backgroundColor: 'white',
  panel_backgroundColor_inverted: 'gray_90',
  panel_borderColor: 'gray_20',
  panel_borderColor_inverted: 'gray_90',
  well_backgroundColor: 'gray_20',
  well_backgroundColor_danger: 'red_20',
  well_backgroundColor_success: 'green_20',
  well_backgroundColor_warning: 'bronze_20',
  well_borderColor_danger: 'red_40',
  well_borderColor_success: 'green_40',
  well_borderColor_warning: 'bronze_40'
};
